import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SelfRegCardComponent } from './pages/wizard/selfreg-card/selfreg-card.component';
import { WizardComponent } from './pages/wizard/wizard.component';
import { CloudflareComponent } from "./pages/wizard/service-selection/cloudlfare/cloudflare.component";
import { TurnstileGuardService } from "./services/turnstile-guard.service";


const routes: Routes = [
	{ path: '', component: CloudflareComponent },
	{ path: 'wizard', component: WizardComponent, canActivate: [TurnstileGuardService] },
	{ path: 'wizard/:cardId', component: WizardComponent, canActivate: [TurnstileGuardService] },
	{ path: 'card/:axonId/:pin', component: SelfRegCardComponent, canActivate: [TurnstileGuardService] },
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
	exports: [RouterModule]
})
export class AppRoutingModule { }
